<template>
  <div class="grid py-3">
    <div class="col-12">
      <h3>
        {{ t('gdprLogs.title') }}
      </h3>
      <p>{{ t('gdprLogs.summary') }}</p>
    </div>
  </div>
  <div class="grid">
    <div class="col-12 col-fixed">
      <SpmTable
        name="ShopsLogsActions"
        index="id_shop_log_action"
        :expand-rows="true"
        :persistent-filters="persistentFilters"
        :table-columns="columns"
      >
        <template #type="slotProps">
          <span v-if="slotProps.data.type === 'doubleoptin'">{{ t('gdprLogs.types.doubleoptin') }}</span>
          <span v-if="slotProps.data.type === 'reclamation'">{{ t('gdprLogs.types.reclamation') }}</span>
          <span v-if="slotProps.data.type === 'datadeletion'">{{ t('gdprLogs.types.datadeletion') }}</span>
          <span v-if="slotProps.data.type === 'accountdeletion'">{{ t('gdprLogs.types.accountdeletion') }}</span>
          <span v-if="slotProps.data.type === 'doubleoptinrevert'">{{ t('gdprLogs.types.doubleoptinrevert') }}</span>
          <span v-if="slotProps.data.type === 'import_doubleoptin'">{{ t('gdprLogs.types.import_doubleoptin') }}</span>
          <span v-if="slotProps.data.type === 'import_list'">{{ t('gdprLogs.types.import_list') }}</span>
          <span v-if="slotProps.data.type === 'cgv'">{{ t('gdprLogs.types.cgv') }}</span>
        </template>
        <template #expandedDetails="slotProps">
          <section :key="slotProps.data.id_shop_log_action">
            <div class="mb-2">
              <span class="font-bold">{{ t('gdprLogs.headers.location') }}</span>
              <pre class="ml-4">{{ slotProps.data.location }}</pre>
            </div>
            <div>
              <span class="font-bold">{{ t('gdprLogs.headers.source_url') }}</span>
              <pre class="ml-4">{{ slotProps.data.source_url }}</pre>
            </div>
          </section>
        </template>
      </SpmTable>
    </div>
  </div>
</template>

<script lang="ts">
import { useI18n } from 'vue-i18n';
import { SpmTableColumns, SpmTableFilter } from '@/types';
import { OperatorType } from '@/types/generated-types/graphql';
import SpmTable from '@/components/table/SpmTable.vue';
import { defineComponent } from 'vue';
import { UserState } from '@/composables/User';

export default defineComponent({
  name: 'GdprLogs',
  components: {
    SpmTable,
  },

  setup() {
    const { t } = useI18n();

    const columns: SpmTableColumns[] = [
      {
        field: 'id_shop_log_action',
        header: '',
        sortable: false,
        filterable: false,
        editable: false,
        style: '',
        type: 'text',
        hidden: true,
      },
      {
        field: 'email',
        header: t('gdprLogs.headers.email'),
        sortable: true,
        filterable: true,
        editable: false,
        style: '',
        type: 'text',
      },
      {
        field: 'type',
        header: t('gdprLogs.headers.type'),
        sortable: true,
        filterable: false,
        editable: false,
        style: '',
        type: 'text',
      },
      {
        field: 'ip',
        header: t('gdprLogs.headers.ip'),
        sortable: true,
        filterable: false,
        editable: false,
        style: '',
        type: 'text',
      },
      {
        field: 'date',
        header: t('gdprLogs.headers.date'),
        sortable: true,
        filterable: false,
        editable: false,
        style: '',
        type: 'text',
      },
      {
        field: 'location',
        header: t('gdprLogs.headers.location'),
        sortable: false,
        filterable: false,
        editable: false,
        style: '',
        type: 'text',
        hidden: true,
      },
      {
        field: 'source_url',
        header: t('gdprLogs.headers.source_url'),
        sortable: false,
        filterable: false,
        editable: false,
        style: '',
        type: 'text',
        hidden: true,
      },
    ];

    const persistentFilters: SpmTableFilter[] = [
      {
        field: 'id_shop',
        value: UserState?.activeShop?.id ?? '',
        operator: OperatorType.Equals,
      },
    ];

    return {
      t,
      columns,
      persistentFilters,
    };
  },
});
</script>
